import {Injectable} from '@angular/core';
import { HttpClient, HttpParams, HttpXsrfTokenExtractor } from '@angular/common/http';
import {ReplaySubject} from 'rxjs';
import {map, switchMap, tap} from 'rxjs/operators';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  google_url = "https://accounts.google.com/o/oauth2/v2/auth";
  scope = "email";
  access_type = "online";
  redirect_uri: string;
  include_granted_scope = "true";
  google_client_id: string;
  response_type = "token";
  local_client_id: string;
  display_name: string;
  access_token;
  token_expires: Date;
  token_type = 'Bearer';
  current_user: ReplaySubject<any> = new ReplaySubject<any>();

  constructor(private http: HttpClient, private tokenExtractor: HttpXsrfTokenExtractor) {
    // this.google_client_id = environment.google_client_id;
    // this.local_client_id = environment.local_client_id;
    // this.redirect_uri = environment.oauth2_redirect_uri;
    this.loadToken();
  }

  // canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
  //   return new Promise(resolve => {
  //     this.loadToken();
  //     this.isTokenValid().pipe(
  //       switchMap(() => {
  //           return this.http.get<any>('/current_user').pipe(
  //             map(response => {
  //               this.display_name = response.name;
  //               resolve(true);
  //             }))
  //         }
  //       ),
  //       catchError(() => this.router.navigate(['login']))
  //     ).subscribe();
  //
  //   })
  // }

  sendToLogin(state?: string) {
    // let params: object = {
    //   scope: this.scope, access_type: this.access_type,
    //   redirect_uri: this.redirect_uri, include_granted_scope: this.include_granted_scope,
    //   client_id: this.google_client_id, response_type: this.response_type,
    //   state: state
    // };
    //
    // let url_params: string[] = Object.keys(params).map(key => key + '=' + params[key]);
    //
    // window.location.href = this.google_url + '?' + url_params.join('&');
    window.location.href = `${environment.oauth_url}?next=${state}`;
  }

  login(username: string, password: string) {
    const formData = new FormData();
    formData.append('username', username);
    formData.append('password', password);

    return this.http.get(`${environment.baseUrl}/rest-auth/login/`, {responseType: 'text'})
      .pipe(
        switchMap(response => {
          formData.append('csrfmiddlewaretoken', this.tokenExtractor.getToken());
          return this.http.post(`${environment.baseUrl}/rest-auth/login/`, formData, {responseType: 'text'});
        }),
        // tap(response => this.setAccessToken(response['token'], 3600)),
        switchMap(() => this.getCurrentUser())
      // ).pipe(catchError(err => {
      //   console.log('Invalid Username or password');
      //   return throwError(err);
      //       })
      )};

  // refreshToken() {
  //   return this.http.post(`${environment.baseUrl}/token-refresh/`, {token: this.access_token})
  //     .pipe(map(response => this.setAccessToken(response['token'], 3600)));
  // }

  convertToken(access_token: string, expires_in: string) {
    return this.http.post(environment.local_token_endpoint, '', {
      params: new HttpParams().set('grant_type', 'convert_token')
        .set('client_id', this.local_client_id)
        .set('backend', 'google-oauth2')
        .set('token', access_token)
    }).pipe(map(response =>
      this.setAccessToken(`Bearer ${response['token']}`, response['expires_in'])));
  }

  setAccessToken(access_token: string, expires_in: number) {
    localStorage.setItem('access_token', access_token);
    this.access_token = access_token;
    let now = new Date().getTime();
    this.token_expires = new Date(now + (expires_in * 24 * 60 * 6000));
    localStorage.setItem('token_expires', this.token_expires.toISOString());
  }

  loadToken() {
    let expiration_date = String(localStorage.getItem('token_expires'));
    this.token_expires = expiration_date !== 'null' ? new Date(expiration_date) : new Date();
    this.access_token = localStorage.getItem('access_token');
  }

  isTokenValid() {
    // return new Observable(obs => {
    let now = new Date();
    return (this.token_expires > now);
    //   if (isValid) {
    //     obs.next();
    //     obs.complete();
    //   } else obs.error();
    // });
  }

  clearToken() {
    delete this.token_expires;
    delete this.access_token;
    this.display_name = '';
    localStorage.clear();
  }

  getCurrentUser() {
    return this.http.get(`${environment.baseUrl}/current_user/`).pipe(
      tap(response => this.current_user.next(response))
    );
  }

  logout() {
    return this.http.get(`${environment.baseUrl}/rest-auth/logout/`, {responseType: 'text'});
  }
}
